import { create } from 'zustand';

export const useIsFeatureFlagLoadedStore = create<{
  isLoaded: boolean;
  setIsLoaded: (isLoaded: boolean) => void;
}>((set) => ({
  isLoaded: false,
  setIsLoaded: (isLoaded: boolean) => set({ isLoaded }),
}));

export const useIsFeatureFlagLoaded = () => {
  return useIsFeatureFlagLoadedStore((s) => s.isLoaded);
};
